<div class="page-wrapper">
  <div class="page">
    <div class="page-header">
      <h1>Submit New Idea</h1>
      <p class="subtitle">{{ editingIdeaId ? 'Edit your draft and continue where you left off.' : 'Share your idea to improve Master Team. Be specific and thoughtful!' }}</p>
    </div>

    <form [formGroup]="form" (ngSubmit)="submitIdea()" class="form-card">
      <div *ngIf="errorMessage" class="form-error" role="alert">{{ errorMessage }}</div>

      <div class="form-group">
        <label>Idea Title <span class="required">*</span></label>
        <input type="text" formControlName="title" placeholder="A clear, concise title for your idea" />
        <span *ngIf="form.get('title')?.touched && form.get('title')?.invalid" class="error">
          Title is required (min 3 characters).
        </span>
        <span class="hint">Make it descriptive and action-oriented</span>
      </div>

      <div class="form-group">
        <label>Category <span class="required">*</span></label>
        <select formControlName="categoryId" [disabled]="loadingCategories || categories.length === 0">
          <option value="">{{ loadingCategories ? 'Loading categories...' : (categories.length === 0 ? 'No categories available' : 'Select a category') }}</option>
          <option *ngFor="let c of categories" [value]="c.id">{{ c.name }}</option>
        </select>
        <span *ngIf="form.get('categoryId')?.touched && form.get('categoryId')?.invalid" class="error">
          Category is required.
        </span>
        <span *ngIf="form.get('categoryId')?.errors?.['invalidGuid']" class="error">
          Category value must be a valid id (GUID).
        </span>
      </div>

      <div class="form-group">
        <label>Brief Description</label>
        <textarea formControlName="briefDescription" rows="3" placeholder="Summarize your idea in 2-3 sentences"></textarea>
      </div>

      <div class="form-group">
        <label>Problem / Opportunity</label>
        <textarea formControlName="problemOpportunity" rows="3" placeholder="What problem does this solve? What opportunity does it address?"></textarea>
        <span class="hint">Help others understand why this matters</span>
      </div>

      <div class="form-group">
        <label>Proposed Solution (Optional)</label>
        <textarea formControlName="proposedSolution" rows="3" placeholder="How would you solve this? What's your proposed approach?"></textarea>
      </div>

      <div class="form-group">
        <label>Impact Scope</label>
        <div class="checkbox-group checkbox-impact-type" formGroupName="impactScope">
          <label class="checkbox-label"><input type="checkbox" formControlName="myTeam" /> My Team</label>
          <label class="checkbox-label"><input type="checkbox" formControlName="myDepartment" /> My Department</label>
          <label class="checkbox-label"><input type="checkbox" formControlName="companyWide" /> Company-wide</label>
          <label class="checkbox-label"><input type="checkbox" formControlName="customers" /> Customers</label>
          <label class="checkbox-label"><input type="checkbox" formControlName="product" /> Product</label>
        </div>
      </div>

      <div class="form-group">
        <label>Expected Impact Type</label>
        <div class="checkbox-group checkbox-impact-type" formGroupName="expectedImpactType">
          <label class="checkbox-label"><input type="checkbox" formControlName="timeSaved" /> Time saved</label>
          <label class="checkbox-label"><input type="checkbox" formControlName="costSaved" /> Cost saved</label>
          <label class="checkbox-label"><input type="checkbox" formControlName="revenue" /> Revenue</label>
          <label class="checkbox-label"><input type="checkbox" formControlName="quality" /> Quality</label>
          <label class="checkbox-label"><input type="checkbox" formControlName="riskReduction" /> Risk reduction</label>
          <label class="checkbox-label"><input type="checkbox" formControlName="employeeExperience" /> Employee experience</label>
        </div>
      </div>

      <div class="form-group">
        <label>Estimated Effort</label>
        <select formControlName="estimatedEffort">
          <option value="low">Low (Days)</option>
          <option value="medium">Medium (Weeks)</option>
          <option value="high">High (Months)</option>
        </select>
        <span class="hint">Your best guess at implementation complexity</span>
      </div>

      <div class="form-group">
        <label>Owner Department (Suggested)</label>
        <select formControlName="ownerDepartment">
          <option value="">Select department</option>
          <option value="product">Product</option>
          <option value="engineering">Engineering</option>
          <option value="design">Design</option>
          <option value="marketing">Marketing</option>
          <option value="operations">Operations</option>
        </select>
      </div>

      <div class="form-group">
        <label>Tags</label>
        <input type="text" formControlName="tags" placeholder="automation, AI, customer-experience (comma-separated)" />
      </div>

      <div class="form-group">
        <label class="checkbox-label standalone"style="background-color: #F9FAFB;padding:  1rem;">
          <input type="checkbox" formControlName="submitAnonymously" />
          Submit anonymously
        </label>
      </div>

      <div class="form-actions">
        <button type="button" class="btn btn-secondary" [disabled]="saving || loadingCategories || loadingIdea" (click)="saveDraft()">
          {{ saving ? 'Saving...' : 'Save Draft' }}
        </button>
        <button type="submit" class="btn btn-primary" [disabled]="saving || loadingCategories || loadingIdea || categories.length === 0"
        style="width: 80%;">
          {{ saving ? 'Submitting...' : 'Submit Idea' }}
        </button>
      </div>
    </form>
  </div>
</div>
